import React, { FC, useCallback, useState } from 'react';
import cn from 'clsx';

import { FormattedPoll } from '@utils/Poll';

import { ChevronLeftIcon } from '@components/elements/Icons';
import PollPickerDialog from './Dialog';
interface PollPickerProps {
  disabled?: boolean;
  placeholder?: string;
  title?: string;
  value?: FormattedPoll;
  onChange?: (value: FormattedPoll) => void;
  className?: string;
  filter?: 'VOTER' | 'PROXY';
}

const PollPicker: FC<PollPickerProps> = ({
  disabled,
  placeholder = 'Select Poll',
  title = 'Select Poll',
  filter = 'PROXY',
  value: propValue,
  className,
  onChange,
}) => {
  const [value, setValue] = useState<FormattedPoll>();
  const [open, setOpen] = useState<boolean>(false);

  const displayValue = propValue !== undefined ? propValue : value;

  const toggleModal = useCallback(() => {
    setOpen(!open);
  }, [setOpen, open]);

  const hideModal = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const _onChange = useCallback(
    (value: FormattedPoll) => {
      onChange?.(value);
      if (propValue === undefined) {
        setValue(value);
      }
    },
    [onChange, propValue]
  );

  return (
    <React.Fragment>
      <PollPickerDialog
        title={title}
        className="text-black bg-yellow"
        filter={filter}
        open={open}
        onCancel={hideModal}
        onSelect={(poll) => {
          _onChange(poll);
        }}
      />
      <div
        role="button"
        className={cn(
          'bg-yellow text-black p-4 flex justify-between items-center',
          { 'cursor-not-allowed': disabled },
          className
        )}
        onClick={disabled ? undefined : toggleModal}
      >
        <div className="flex items-center space-x-4">
          {displayValue && (
            <div>
              <div className="w-10 h-10 rounded-full">
                <img
                  className="object-cover w-full h-full rounded-full"
                  src={displayValue.image?.url}
                  alt="poll"
                />
              </div>
            </div>
          )}
          <div
            className={cn(
              'font-bold overflow-hidden leading-6 break-all sm:break-words',
              {
                'text-gray-800': displayValue?.title === undefined,
              }
            )}
          >
            {displayValue?.title || placeholder}
          </div>
        </div>
        <div>
          <ChevronLeftIcon
            className={cn('transform duration-75', {
              '-rotate-90': !open,
              'rotate-90': open,
            })}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default PollPicker;
